import TooltipButton from "@/shared/components/TooltipButton/TooltipButton.vue";
import TooltipToggleButton from "@/shared/components/TooltipToggleButton/TooltipToggleButton.vue";
import { OPTIONS_LOCALE_DATE } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import {
  EMITTED_EVENT,
  EVENT,
  ICONS_COLORS,
  MAIN_FILTER
} from "../../constants/EventConstants";
import { DOWNLOAD_ONLY_CATEGORY } from "@/modules/Document/constants/DocumentConstants";
import { IMG_SOURCE } from "@/shared/components/ChatBot/constants/ChatBotConstants";

Vue.use(Vuetify);

@Component({
  name: "EventTitle",
  components: {
    TooltipButton,
    TooltipToggleButton
  }
})
export default class EventTitle extends Vue {
  @Prop({ default: true })
  private isTimeline!: boolean;
  @Prop({ default: "" })
  private title!: string;
  @Prop({ default: "" })
  private eventType!: string;
  @Prop({ default: 0 })
  private dateCreated!: number;
  @Prop({ default: "" })
  private eventState!: string;

  ICON_COLORS = ICONS_COLORS;
  DOCUMENT = MAIN_FILTER.DOCUMENT;
  FORM = MAIN_FILTER.FORM;
  IMG_SOURCE = IMG_SOURCE;

  options = OPTIONS_LOCALE_DATE;
  basicBtnClassRound = STYLE_CLASSES.BASIC_ROUND_BTN;
  BTN_HINT = EVENT.BTN_HINT;
  toggleHint = EVENT.BTN_HINT.SHOW_DETAILS;
  state = false;
  DOWNLOAD_ONLY = DOWNLOAD_ONLY_CATEGORY;
  toggleSwitch(state: boolean) {
    if (state) {
      this.$emit(EMITTED_EVENT.SHOW_DETAILS);
      this.toggleHint = EVENT.BTN_HINT.HIDE_DETAILS;
      this.state = state;
    } else {
      this.$emit(EMITTED_EVENT.HIDE_DETAILS);
      this.toggleHint = EVENT.BTN_HINT.SHOW_DETAILS;
      this.state = state;
    }
  }

  showNotes() {
    this.$emit(EMITTED_EVENT.SHOW_NOTES);
  }

  showPreview() {
    this.$emit(EMITTED_EVENT.SHOW_PREVIEW);
  }

  shareDocument() {
    this.$emit(EMITTED_EVENT.SHARE_DOCUMENT);
  }

  editDocument() {
    this.$emit(EMITTED_EVENT.EDIT_DOCUMENT);
  }

  summaryDocument() {
    this.$emit(EMITTED_EVENT.SUMMARY_DOCUMENT);
  }
}
